/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocation_Form_No_Allocatable_ResourcesInputs */

const en_admin_allocation_form_no_allocatable_resources = /** @type {(inputs: Admin_Allocation_Form_No_Allocatable_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No allocatable resources available. Please create a resource with usage set to "allocatable" first.`)
};

const de_admin_allocation_form_no_allocatable_resources = /** @type {(inputs: Admin_Allocation_Form_No_Allocatable_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine zuweisbaren Ressourcen verfügbar. Bitte erstelle zuerst eine Ressource mit der Nutzungstyp „zuweisbar".`)
};

const es_admin_allocation_form_no_allocatable_resources = /** @type {(inputs: Admin_Allocation_Form_No_Allocatable_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay recursos asignables disponibles. Por favor, crea primero un recurso con tipo de uso establecido como "asignable".`)
};

const fr_admin_allocation_form_no_allocatable_resources = /** @type {(inputs: Admin_Allocation_Form_No_Allocatable_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune ressource attribuable disponible. Veuillez d'abord créer une ressource avec l'utilisation définie sur « attribuable ».`)
};

/** @type {(inputs: Admin_Allocation_Form_No_Allocatable_ResourcesInputs) => LocalizedString} */
const it_admin_allocation_form_no_allocatable_resources = en_admin_allocation_form_no_allocatable_resources;

/** @type {(inputs: Admin_Allocation_Form_No_Allocatable_ResourcesInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_no_allocatable_resources = en_admin_allocation_form_no_allocatable_resources;

/** @type {(inputs: Admin_Allocation_Form_No_Allocatable_ResourcesInputs) => LocalizedString} */
const pl_admin_allocation_form_no_allocatable_resources = en_admin_allocation_form_no_allocatable_resources;

/** @type {(inputs: Admin_Allocation_Form_No_Allocatable_ResourcesInputs) => LocalizedString} */
const hu_admin_allocation_form_no_allocatable_resources = en_admin_allocation_form_no_allocatable_resources;

/** @type {(inputs: Admin_Allocation_Form_No_Allocatable_ResourcesInputs) => LocalizedString} */
const ro_admin_allocation_form_no_allocatable_resources = en_admin_allocation_form_no_allocatable_resources;

/**
* | output |
* | --- |
* | "No allocatable resources available. Please create a resource with usage set to \"allocatable\" first." |
*
* @param {Admin_Allocation_Form_No_Allocatable_ResourcesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_no_allocatable_resources = /** @type {((inputs?: Admin_Allocation_Form_No_Allocatable_ResourcesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_No_Allocatable_ResourcesInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_no_allocatable_resources(inputs)
	if (locale === "de") return de_admin_allocation_form_no_allocatable_resources(inputs)
	if (locale === "es") return es_admin_allocation_form_no_allocatable_resources(inputs)
	if (locale === "fr") return fr_admin_allocation_form_no_allocatable_resources(inputs)
	if (locale === "it") return it_admin_allocation_form_no_allocatable_resources(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_no_allocatable_resources(inputs)
	if (locale === "pl") return pl_admin_allocation_form_no_allocatable_resources(inputs)
	if (locale === "hu") return hu_admin_allocation_form_no_allocatable_resources(inputs)
	return ro_admin_allocation_form_no_allocatable_resources(inputs)
});
export { admin_allocation_form_no_allocatable_resources as "admin.allocation_form.no_allocatable_resources" }